exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-popper{padding:0;background:#fff;border-radius:8px;min-width:80px;box-shadow:0 0 24px 0 rgb(0 0 0/20%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71dbb390","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/common/top-bar-new.vue
// module id = 183
// module chunks = 1 5